<template>
    <ui-modal icon="far fa-cog" name="modal-sales-table-clone" title="Clonar tabela de vendas" size="xs" :load="load">
        <div class="modal-content-line">
            <ui-select v-model="selected" :clearable="false" label="Selecione uma tabela:">
                <optgroup v-if="optionsFiled != ''" label="Tabelas Arquivadas">
                    <option
                        v-for="option in optionsFiled"
                        :key="option.id"
                        :value="option.id"
                        :selected="option.id === selected">
                        {{ option.name }}
                    </option>
                </optgroup>

                <optgroup v-if="options != ''" label="Tabelas Ativas">
                    <option
                        v-for="option in options"
                        :key="option.id"
                        :value="option.id"
                        :selected="option.id === selected">
                        {{ option.name }}
                    </option>
                </optgroup>
            </ui-select>
        </div>

        <template #footer>
            <ui-button design="primary md" @click="clone">Clonar</ui-button>
            <ui-button design="danger md" @click="close">Cancelar</ui-button>
        </template>
    </ui-modal>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelect } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'

	import { mapGetters } from 'vuex'

	export default {
		name:"modal-sales-table-clone",
		components: {
			uiButton,
			uiSelect,
			uiModal,
		},

		data() {
			return {
				selected: null,
				load: false,
				options: [],
				optionsFiled: [],
				unsubscribe: null,
			}
		},

		computed: {
			...mapGetters('salesTable', {
				salesTableCloneOptions: 'getSalesTableCloneOptions',
			}),
		},

		created() {
			this.unsubscribe = this.$store.subscribe((mutation) => {
				/** Updates the contents of the table */
				if (mutation.type === 'salesTable/SET_SALES_TABLE_CLONE_OPTIONS') {
					this.setOptions()
				}
			})
		},

		mounted() {
			this.$root.$on('modal-close-modal-sales-table-clone-remove-load', () => {
				this.load = false
				this.close()
			})
		},

		beforeDestroy() {
			this.unsubscribe()
			this.$root.$off("modal-close-modal-sales-table-clone-remove-load")
		},

		methods: {
			/**
			 * Clone the selected table
			 */
			clone() {
				if (this.selected) {
					this.load = true
					this.$root.$emit('clone-existing-sales-table', this.selected)
				} else {
					this.$toastr.w('É necessário selecionar uma tabela para realizar a clonagem.')
				}
			},

			/**
			 * Hides the current mode
			 */
			close() {
				this.$root.$emit('modal-close-modal-sales-table-clone', false)
			},

			/**
			 * Check if the end date of the table is earlier than today's date
			 */
			isSameOrBefore(date) {
				const moment = require('moment')
				require('moment/locale/pt-br')
				return moment().isSameOrBefore(date, 'day')
			},

			/**
			 * Fill the select with the correct options by group
			 */
			setOptions() {
				let options = [...this.salesTableCloneOptions]
				this.options = options.filter((option) => {
					return this.isSameOrBefore(option.end_date)
				})
				this.optionsFiled = options.filter((option) => {
					return !this.isSameOrBefore(option.end_date)
				})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
